import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { wipQueryKey } from "../account.keys";

export type AdminWipStatement = Dtos.Admin.WipStatement.Get.Response;

export const useAdminFetchAccountWorkInProgressStatements = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isFetching, isLoading, isFetched, refetch } = useQuery({
		queryKey: wipQueryKey(accountId),
		queryFn: async () =>
			await get<AdminWipStatement[]>(
				`/v2/admin/surety/accounts/${accountId}/work-in-progress-statements`,
			),
		retry: false,
	});

	return {
		wipStatements: data,
		wipStatementsError: error,
		wipStatementsIsFetching: isFetching,
		wipStatementsIsLoading: isLoading,
		wipStatementsIsFetched: isFetched,
		refetchWipStatements: refetch,
	};
};
